
    import("./node_modules/@gouvfr/dsfr/dist/dsfr/dsfr.module.min.js");
  